export enum WhatsAppTemplateStatus
{
    CREATED =0,
    APPROVED =1,
    PENDING =2,
    REJECTED=3
}

export enum TemplateType
{
    TextBased = 1,
    MediaBased = 2,
    LocationBased=3
}